<template>
  <div class="media-stats-container">
    <div class="header-section">
      <h1>媒体统计</h1>
      <div class="date-range">
        <input type="date" v-model="startDate" @change="updateStats" />
        <span>至</span>
        <input type="date" v-model="endDate" @change="updateStats" />
      </div>
    </div>
    
    <div class="stats-overview">
      <div class="stat-card">
        <div class="stat-value">{{ totalMedia }}</div>
        <div class="stat-label">总媒体数</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ formatSize(totalSize) }}</div>
        <div class="stat-label">总存储空间</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ recentUploads }}</div>
        <div class="stat-label">本周上传</div>
      </div>
    </div>
    
    <div class="charts-container">
      <div class="chart-card">
        <h3>媒体类型分布</h3>
        <div class="media-type-pie">
          <div class="pie-chart">
            <div class="pie-slice" 
                 v-for="(item, index) in mediaTypeData" 
                 :key="item.type"
                 :style="getPieStyle(item.percentage, index)">
            </div>
            <div class="pie-center"></div>
          </div>
          <div class="legend">
            <div class="legend-item" v-for="item in mediaTypeData" :key="item.type">
              <div class="legend-color" :style="{ backgroundColor: item.color }"></div>
              <span>{{ item.label }}: {{ item.count }} ({{ item.percentage }}%)</span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="chart-card">
        <h3>上传趋势</h3>
        <div class="upload-trend">
          <div class="trend-bars">
            <div class="bar-container" v-for="item in uploadTrendData" :key="item.date">
              <div class="bar" :style="{ height: getBarHeight(item.count) + '%' }"></div>
              <div class="bar-label">{{ item.date }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="recent-uploads">
      <h3>最近上传</h3>
      <div class="uploads-table">
        <table>
          <thead>
            <tr>
              <th>文件名</th>
              <th>类型</th>
              <th>大小</th>
              <th>上传时间</th>
              <th>上传人</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in recentUploadsList" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ getMediaTypeLabel(item.type) }}</td>
              <td>{{ formatSize(item.size) }}</td>
              <td>{{ formatDate(item.createdAt) }}</td>
              <td>{{ item.uploader }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaStats',
  data() {
    return {
      startDate: this.getDateDaysAgo(30),
      endDate: this.getTodayDate(),
      // 模拟数据
      mediaStats: {
        totalMedia: 128,
        totalSize: 524288000, // 500MB
        mediaTypeDistribution: [
          { type: 'image', count: 85, percentage: 66.4, color: '#4f46e5' },
          { type: 'video', count: 27, percentage: 21.1, color: '#10b981' },
          { type: 'audio', count: 16, percentage: 12.5, color: '#f59e0b' }
        ],
        uploadTrend: [
          { date: '7/15', count: 8 },
          { date: '7/16', count: 12 },
          { date: '7/17', count: 5 },
          { date: '7/18', count: 15 },
          { date: '7/19', count: 9 },
          { date: '7/20', count: 6 },
          { date: '7/21', count: 11 }
        ],
        recentUploads: [
          { id: 1, name: '新产品宣传图.jpg', type: 'image', size: 2048000, createdAt: '2023-07-21T14:30:00Z', uploader: '张三' },
          { id: 2, name: '演示视频.mp4', type: 'video', size: 15728640, createdAt: '2023-07-21T10:15:00Z', uploader: '李四' },
          { id: 3, name: '背景音乐.mp3', type: 'audio', size: 3145728, createdAt: '2023-07-20T16:45:00Z', uploader: '王五' },
          { id: 4, name: 'UI设计稿.png', type: 'image', size: 4096000, createdAt: '2023-07-20T09:20:00Z', uploader: '赵六' },
          { id: 5, name: '产品展示视频.mp4', type: 'video', size: 20971520, createdAt: '2023-07-19T15:10:00Z', uploader: '张三' }
        ]
      }
    };
  },
  computed: {
    totalMedia() {
      return this.mediaStats.totalMedia;
    },
    totalSize() {
      return this.mediaStats.totalSize;
    },
    recentUploads() {
      return this.mediaStats.recentUploads;
    },
    mediaTypeData() {
      return this.mediaStats.mediaTypeDistribution.map(item => ({
        ...item,
        label: this.getMediaTypeLabel(item.type)
      }));
    },
    uploadTrendData() {
      return this.mediaStats.uploadTrend;
    },
    recentUploadsList() {
      return this.mediaStats.recentUploads;
    }
  },
  created() {
    this.updateStats();
  },
  methods: {
    updateStats() {
      // 这里可以根据日期范围获取统计数据
      console.log('更新统计数据:', this.startDate, this.endDate);
      // 实际项目中这里应该调用API获取数据
    },
    getDateDaysAgo(days) {
      const date = new Date();
      date.setDate(date.getDate() - days);
      return date.toISOString().split('T')[0];
    },
    getTodayDate() {
      return new Date().toISOString().split('T')[0];
    },
    formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(2) + ' MB';
      else return (bytes / 1073741824).toFixed(2) + ' GB';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString();
    },
    getMediaTypeLabel(type) {
      const labels = {
        'image': '图片',
        'video': '视频',
        'audio': '音频'
      };
      return labels[type] || type;
    },
    getPieStyle(percentage, index) {
      const startAngle = this.getStartAngle(index);
      const endAngle = startAngle + (percentage / 100) * 360;
      
      return {
        background: `conic-gradient(
          ${this.mediaTypeData[index].color} ${startAngle}deg,
          ${this.mediaTypeData[index].color} ${endAngle}deg,
          transparent ${endAngle}deg,
          transparent ${startAngle}deg
        )`
      };
    },
    getStartAngle(index) {
      let startAngle = 0;
      for (let i = 0; i < index; i++) {
        startAngle += (this.mediaTypeData[i].percentage / 100) * 360;
      }
      return startAngle;
    },
    getBarHeight(count) {
      const maxCount = Math.max(...this.uploadTrendData.map(item => item.count));
      return (count / maxCount) * 100;
    }
  }
};
</script>

<style scoped>
.media-stats-container {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-section h1 {
  font-size: 24px;
  color: #1e293b;
  margin: 0;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-range input[type="date"] {
  padding: 6px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
}

.stats-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  padding: 20px;
  background-color: #f8fafc;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #e2e8f0;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #4f46e5;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #64748b;
}

.charts-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

.chart-card {
  padding: 20px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.chart-card h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #1e293b;
}

.media-type-pie {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.pie-chart {
  position: relative;
  width: 150px;
  height: 150px;
}

.pie-slice {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.pie-center {
  position: absolute;
  width: 40%;
  height: 40%;
  background-color: #f8fafc;
  border-radius: 50%;
  top: 30%;
  left: 30%;
}

.legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.upload-trend {
  height: 200px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 30px;
  position: relative;
}

.trend-bars {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  gap: 10px;
}

.bar-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.bar {
  width: 100%;
  background-color: #4f46e5;
  border-radius: 4px 4px 0 0;
  transition: height 0.3s ease;
}

.bar-label {
  font-size: 12px;
  color: #64748b;
}

.recent-uploads h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #1e293b;
}

.uploads-table table {
  width: 100%;
  border-collapse: collapse;
}

.uploads-table th,
.uploads-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.uploads-table th {
  font-weight: 600;
  color: #1e293b;
  background-color: #f8fafc;
}

.uploads-table td {
  color: #64748b;
}

@media (max-width: 768px) {
  .header-section {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .date-range {
    justify-content: center;
  }
  
  .charts-container {
    grid-template-columns: 1fr;
  }
  
  .media-type-pie {
    flex-direction: column;
    gap: 20px;
  }
  
  .uploads-table {
    overflow-x: auto;
  }
  
  .uploads-table table {
    min-width: 600px;
  }
}
</style>